import { call, fork, take, put } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'
import { AutorisationROApi } from '../../api/instances'
import { getCurrentUser, getCurrentUserInitiated } from './settings.actions'
import { requestFailed, requestFinished, requestStarted } from '../common/common.actions'

// getCurrentUser
const getUserAccountWorker = bindAsyncAction(getCurrentUser)(
  function * () {
    return yield call([AutorisationROApi, AutorisationROApi.getCurrentUser])
  },
)

function * watchGetUserAccountInitiated () {
  while (true) {
    const action: Action<undefined> = yield take(getCurrentUserInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getUserAccountWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      // Ensure the error has the proper structure with status for 401 detection
      let structuredError = e
      if (e && typeof e === 'object' && 'response' in e) {
        // If it's a ResponseError with a response property, extract the response
        structuredError = (e as any).response
      } else if (e && typeof e === 'object' && 'status' in e) {
        // If it already has a status property, use it as is
        structuredError = e
      } else {
        // If no status is available, create a generic error structure
        // Check if e is an object before spreading
        if (e && typeof e === 'object') {
          structuredError = { ...e, status: 500 }
        } else {
          // Handle primitive types or null/undefined
          structuredError = {
            message: String(e),
            originalError: e,
            status: 500
          }
        }
      }

      yield put(requestFailed({ type: action.type, error: structuredError }))
      console.error('error in watchGetUserAccountInitiated: ', e)
    }
  }
}

export function * settingsSagas () {
  yield fork(watchGetUserAccountInitiated)
}
